module.exports = __webpack_public_path__ + "static/img/pic2.effcaeba.png";